import { AppAction } from "../../../root/AppAction";
import { Template } from "../../models/Template";
import TemplateEvents from "../events/TemplateEvents";

export interface TemplateStore {
    templateList: Template[];
    isLoading: boolean;
    isDeleteTemplateFailed: boolean;
    isDeleteTemplateCompleted:boolean;
    deleteError: string;
}

const initialTemplateStore: TemplateStore = {
    templateList: [],
    isLoading: false,
    isDeleteTemplateFailed: false,
    isDeleteTemplateCompleted:false,
    deleteError: "",
};

export function template(state: TemplateStore = initialTemplateStore, action: AppAction) {
    switch (action.type) {
        // テンプレート更新
        case TemplateEvents.UpdateTemplateStarted:
            return {
                ...state,
                isLoading: true,
            };

        case TemplateEvents.UpdateTemplateComplete:
            return {
                ...state,
                isLoading: false,
                templateList: action.templateList,
                isDeleteTemplateSuccess: false,
                isDeleteTemplateFailed: false,
            };

        // テンプレート削除
        case TemplateEvents.DeleteTemplateStarted:
            return {
                ...state,
                isDeleteTemplateFailed: false,
                isDeleteTemplateCompleted: false
            };

        case TemplateEvents.DeleteTemplateComplete:
            return {
                ...state,
                templateList: action.templateList,
                isDeleteTemplateCompleted:true,
            };
        // テンプレート削除失敗
        case TemplateEvents.DeleteTemplateFailed:
            return {
                ...state,
                templateList: action.templateList,
                deleteError: action.error,
                isDeleteTemplateFailed: true,
            };
        // 削除エラーリセット
        case TemplateEvents.ResetDeleteTemplateError:
            return {
                ...state,
                isDeleteTemplateFailed: false,
                isDeleteTemplateCompleted:false,
                deleteError: "",
            };

        // テンプレート名変更完了
        case TemplateEvents.RenameTemplateComplete:
            return {
                ...state,
                templateList: action.templateList,
            };

        // テンプレート一覧取得
        case TemplateEvents.GetTemplatesComplete:
            return {
                ...state,
                templateList: action.templateList,
            };

        default:
            return state;
    }
}
